import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMessage,
  faXmark,
  faPaperPlane,
  faUser,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import "./Chatbothome.css";
import MessageNotifierOwl from "../../images/LandingPageImage/MSG-Notifier.gif";
import MessageNotifierBanner from "../../images/msgnotifier.svg";
import { basicauth } from "../../utils/Crediantials";

const WS_URL = "wss://blogapi.bumppy.com/ws/admin-chat";

const ChatBotHome = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState("list");
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [UserClient, setUserClient] = useState("");
  const [verificationMethod, setVerificationMethod] = useState("email");

  const socketRef = useRef(null);
  const messagesEndRef = useRef(null);

  const { username, password } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  /* ----------- WS LOGIC (UNCHANGED) ----------- */
  const connectWebSocket = () => {
    if (socketRef.current) return;

    const socket = new WebSocket(WS_URL);
    socketRef.current = socket;

    socket.onopen = () => {
      console.log("🟢 WebSocket Connected");
    };

    socket.onmessage = (event) => {
      console.log("📩 WS MESSAGE:", event.data);

      const msg = JSON.parse(event.data);

      if (msg.type === "NEW_CHAT") {
        setMessages((prev) => [
          ...prev,
          {
            id: Date.now(),
            message: msg.data.lastMessage,
            type: msg.data.type === "SENT" ? "SENT" : "RECEIVED",
            datetime: msg.data.time,
          },
        ]);
      }
    };

    socket.onerror = (e) => {
      console.error("❌ WebSocket Error", e);
    };

    socket.onclose = () => {
      console.log("🔴 WebSocket Closed");
      socketRef.current = null;
    };
  };

  /* 🔌 START SOCKET WHEN CHAT OPENS */
  useEffect(() => {
    if (view === "chatHistory") {
      connectWebSocket();
    }
  }, [view]);

  /* 🧹 CLEANUP */
  useEffect(() => {
    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
    };
  }, []);

  /* ----------- SEND MESSAGE (UNCHANGED) ----------- */
  const SendText = async () => {
    if (!newMessage.trim()) return;

    await fetch(`https://blogapi.bumppy.com/api/Support/sendSupportChatUser`, {
      method: "POST",
      headers: {
        Authorization: `Basic ${base64Credentials}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        mobile: UserClient,
        message: newMessage,
      }),
    });

    setNewMessage("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    SendText();
  };

  const handleNewChat = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const mobile = formData.get("phone");

    setUserClient(mobile);
    setView("chatHistory");

    await fetch(
      `https://blogapi.bumppy.com/api/Support/submitChatUserDetails`,
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName: formData.get("name"),
          userEmail: formData.get("email"),
          userMobile: mobile,
        }),
      },
    );
  };

  const handleVerification = (e) => {
    e.preventDefault();
    const mobile = new FormData(e.target).get("verification");
    setUserClient(mobile);
    setView("chatHistory");
  };

  return (
    <div className="chat-wrapper">
      {!isOpen && (
        <button className="chat-fab" onClick={() => setIsOpen(true)}>
          <img src={MessageNotifierOwl} alt="chat" className="chat-bot-icon" />
        </button>
      )}

      {isOpen && (
        <div className="chat-box">
          {/* HEADER */}
          <div className="chat-header">
            <div>
              <h1>
                Hello <span>👋</span>
              </h1>
              <h2>Welcome to Message Notifier</h2>
               <p className="custom_header_subtitle changing-text">
                Need help with <p className="word "></p> ?
              </p>
              
            </div>
            <div className="chat-header-actions">
              <FontAwesomeIcon
                icon={faXmark}
                onClick={() => setIsOpen(false)}
              />
            </div>
          </div>

          {/* BODY */}
          <div className="chat-body">
            {view === "list" && (
              <>
                <div className="custom_chat_card_banner">
                  <img className="fade-in" src={MessageNotifierBanner} alt="" />
                </div>

                <div
                  onClick={() => setView("verifyUser")}
                  className="custom_chat_card"
                >
                  <div className="custom_card_header">
                    <div className="custom_card_info">
                      <div className="custom_avatar custom_avatar_continue chat-gray">
                        <FontAwesomeIcon icon={faUser} />
                      </div>
                      <div className="custom_card_text">
                        <h5 className="custom_card_title">
                          Continue Conversation
                        </h5>
                        <p className="custom_card_subtitle">
                          View your chat history
                        </p>
                      </div>
                    </div>
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      className="custom_card_arrow"
                    />
                  </div>
                </div>

                <div
                  className="custom_chat_card"
                  onClick={() => setView("newChat")}
                >
                  <div className="custom_card_header">
                    <div className="custom_card_info">
                      <div className="custom_avatar chat chat-blue">
                        <FontAwesomeIcon icon={faMessage} />
                      </div>
                      <div className="custom_card_text">
                        <h5 className="custom_card_title">Start New Chat</h5>
                        <p className="custom_card_subtitle">
                          Get help from our team
                        </p>
                      </div>
                    </div>
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      className="custom_card_arrow"
                    />
                  </div>
                </div>

                <div className="chat-footer-text">
                  — Welcome to Message Notifier Support
                </div>
              </>
            )}

            {view === "verifyUser" && (
              <form onSubmit={handleVerification} className="chat-form">
                <div
                  className="pill-switch"
                  style={{
                    display: "flex",
                    gap: "10px",
                    marginBottom: "16px",
                  }}
                >
                  <button
                    type="button"
                    style={{
                      flex: 1,
                      padding: "10px 0",
                      borderRadius: "5px",
                      border:
                        verificationMethod === "email"
                          ? "1px solid #705CFE"
                          : "1px solid #ccc",
                      backgroundColor:
                        verificationMethod === "email" ? "#705CFE" : "#f5f5f5",
                      color: verificationMethod === "email" ? "#fff" : "#333",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                    onClick={() => setVerificationMethod("email")}
                  >
                    Email
                  </button>

                  <button
                    type="button"
                    style={{
                      flex: 1,
                      padding: "10px 0",
                      borderRadius: "5px",
                      border:
                        verificationMethod === "mobile"
                          ? "1px solid #705CFE"
                          : "1px solid #ccc",
                      backgroundColor:
                        verificationMethod === "mobile" ? "#705CFE" : "#f5f5f5",
                      color: verificationMethod === "mobile" ? "#fff" : "#333",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                    onClick={() => setVerificationMethod("mobile")}
                  >
                    Mobile
                  </button>
                </div>

                <label>
                  Enter your{" "}
                  {verificationMethod === "email" ? "Email" : "Mobile Number"}
                </label>

                <input
                  name="verification"
                  required
                  placeholder={
                    verificationMethod === "email"
                      ? "your@email.com"
                      : "1234567890"
                  }
                />

                <button className="primary-btn">Continue Chat</button>
                <button
                  type="button"
                  className="secondary-btn"
                  onClick={() => setView("list")}
                >
                  Back to Menu
                </button>
              </form>
            )}

            {view === "newChat" && (
              <form onSubmit={handleNewChat} className="chat-form">
                <label>Name</label>
                <input name="name" required placeholder="Jhonny Bravo" />

                <label>Email</label>
                <input name="email" required placeholder="email@example.com" />

                <label>Phone</label>
                <input name="phone" required placeholder="840xxxxxx" />

                <button className="primary-btn">Start Chat</button>
                <button
                  type="button"
                  className="secondary-btn"
                  onClick={() => setView("list")}
                >
                  Back to Menu
                </button>
              </form>
            )}

            {view === "chatHistory" && (
              <div className="messages">
                {messages.map((m) => (
                  <div
                    key={m.id}
                    className={`bubble ${
                       m.type === "RECEIVED" ? "sent" : "received"
                    }`}
                  >
                    <div>{m.message}</div>
                    <span className="custom_message_time">{m.datetime}</span>
                  </div>
                ))}
                <div ref={messagesEndRef} />
              </div>
            )}
          </div>

          {/* INPUT */}
          {view === "chatHistory" && (
            <form onSubmit={handleSubmit} className="chat-input">
              <input
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                placeholder="Type your message..."
              />
              <button>
                <FontAwesomeIcon icon={faPaperPlane} />
              </button>
            </form>
          )}
        </div>
      )}
    </div>
  );
};

export default ChatBotHome;
